import React, { useState, useContext, useEffect } from "react";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Checkbox,
} from "antd";
import signinLogo1 from "../../assets/images/Logo.svg";
import signinLogo from "../../assets/images/login.svg";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useParams } from "react-router";
import { Severty, ShowToast } from "../../helper/toast";
import signinbg from "../../assets/images/login.svg";
import callApi from "../../constants/API/CallApi";
import { resetPassword, verifyToken } from "../../constants/API/API";

const { Title } = Typography;
const { Content } = Layout;

const Forgot = () => {
  const { token } = useParams();
  const { setUserProfile } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigator = useNavigate();

  useEffect(() => {
    if (token) {
      callApi({
        callback: verifyToken,
        payload: token,
        onSuccess: ({ data }) => {
          console.log(data);
        },
        onError: (err) => {
          ShowToast(err, Severty.ERROR);
          navigator("/login");
        },
      });
    } else {
      navigator("/login");
    }
  }, [token]);

  const onFinish = (value) => {
    const { password } = value;
    setLoading(true);
    callApi({
      callback: resetPassword,
      payload: [token, { password }],
      onSuccess: ({ data, message }) => {
        setLoading(false);
        ShowToast(message, Severty.SUCCESS);
        navigator("/login");
      },
      onError: (err) => {
        setLoading(false);
        console.log(err);
        ShowToast(err, Severty.SUCCESS);
      },
    });
  };

  const onFinishFailed = () => {};

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row>
            <Col span={24} lg={13} className="signin-bg">
              <div className="signin_img">
                {/* <img src={signinLogo} /> */}
              </div>
            </Col>
            <Col span={24} lg={11}>
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={signinLogo1} alt="" />
                </div>
                <Row justify="space-around">
                  <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                    <div className="signup-form">
                      <Title className="mb-15">Reset Password</Title>
                      <Title className="font-regular text-muted" level={5}>
                        See what is going on with your business
                      </Title>
                      <Form
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        layout="vertical"
                        className="row-col"
                      >
                        <Form.Item
                          className="password"
                          label="New Password"
                          name="password"
                          rules={[
                            {
                              validator: (_, value) => {
                                if (!value) {
                                  return Promise.reject(
                                    "Please enter your password!"
                                  );
                                }
                                if (value.length < 8) {
                                  return Promise.reject(
                                    "Password must be at least 8 characters."
                                  );
                                }
                                if (value.length > 15) {
                                  return Promise.reject(
                                    "Password must be at most 15 characters"
                                  );
                                }
                                if (!/[a-z]/.test(value)) {
                                  return Promise.reject(
                                    "Password must contain at least one lowercase letter."
                                  );
                                }
                                if (!/[A-Z]/.test(value)) {
                                  return Promise.reject(
                                    "Password must contain at least one uppercase letter."
                                  );
                                }
                                if (!/\d/.test(value)) {
                                  return Promise.reject(
                                    "Password must contain at least one number."
                                  );
                                }
                                if (!/[^a-zA-Z0-9]/.test(value)) {
                                  return Promise.reject(
                                    "Password must contain at least one special character."
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input.Password
                            onCut={(e) => e.preventDefault()}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            autoComplete="off"
                            placeholder="Enter Password"
                          />
                        </Form.Item>
                        <Form.Item
                          name="confirm"
                          label="Confirm New Password"
                          dependencies={["password"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value) {
                                  return Promise.reject(
                                    "Please enter confirm password!"
                                  );
                                }
                                if (
                                  !value ||
                                  getFieldValue("password") === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error(
                                    "The new and confirm password do not match!"
                                  )
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password
                            onCut={(e) => e.preventDefault()}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            autoComplete="off"
                            placeholder="Enter Confirm Password"
                          />
                        </Form.Item>

                        <Form.Item>
                          <Button
                            className="float-right"
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                          >
                            Reset
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default Forgot;
